import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-99a3a910"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "app-header" };
var _hoisted_2 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("a", {
    class: "logo",
    href: "#"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "iconfont Navbar_logo" })
], -1); });
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("a", {
    class: "search",
    href: "#/search"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "iconfont ic_search_tab" })
], -1); });
var _hoisted_4 = {
    class: "face",
    href: "#/login"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "down-app" }, [
    /*#__PURE__*/ _createElementVNode("a", { href: "https://dl.hdslb.com/mobile/fixed/bili_win/bili_win-install.exe?t=20220722&spm_id_from=333.47.b_646f776e6c6f61642d6c696e6b.9" }, "下载app")
], -1); });
import { mainStore } from '../stores/user';
export default /*#__PURE__*/ _defineComponent({
    __name: 'app-header',
    setup: function (__props) {
        var store = mainStore();
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("header", _hoisted_1, [
                _hoisted_2,
                _hoisted_3,
                _createElementVNode("a", _hoisted_4, [
                    _createElementVNode("img", {
                        src: _unref(store).login,
                        alt: ""
                    }, null, 8, _hoisted_5)
                ]),
                _hoisted_6
            ]));
        };
    }
});
